import { gql } from '@apollo/client';

export function landmarksQuery({ cityId }) {
  const name = `LandmarksQuery_${cityId}`;
  return gql`
    query ${name}($cityId: ID!, $latitude: Float!, $longitude: Float!) {
      landmarks(cityId: $cityId, latitude: $latitude, longitude: $longitude) {
        id
        name
        locationGroupId
      }
    }
  `;
}

const temp = 'just for eslint';

export default temp;
